import script from "./ProjectVideoPlayerSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectVideoPlayerSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectVideoPlayerSection.vue?vue&type=style&index=0&id=4b251de0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b251de0"]])

export default __exports__